/**
 * The board's information popup — a 1:1 port of
 * report/mvc/tmpl/information_popup.tmpl, appended to #main_content on the
 * 'show:report:generation:popup' dispatch (view/main.js:57-59) when the
 * Submittal 1h guard trips (controller/action.js:213-218). Close (#btn_cancel,
 * also the ESC target via the shared popup-keys handler) removes it
 * (main.js:219-221).
 *
 * The Submittal wording is the default, which is the only thing the legacy
 * ever showed here. `heading`/`lines` let the same popup carry a reason the
 * server gave for refusing a generate — there is no toast or banner on this
 * board, so this is where a message goes.
 */
interface ReportGenerationPopupProps {
  onClose: () => void;
  heading?: string;
  lines?: string[];
}

const SUBMITTAL_LINES = [
  'A version of this Submittal Package Report is already in the process of being generated.',
  '',
  'Please wait until the report generation is completed,',
  'in order to generate it again.',
];

const ReportGenerationPopup = ({
  onClose,
  heading = 'Submittal Package Report ',
  lines = SUBMITTAL_LINES,
}: ReportGenerationPopupProps) => (
  <div className="report-generation-popup popup-wrapper width-small active">
    <div className="popup-content-part popup-content">
      <h2 className="popup-heading">{heading}</h2>
      <p className="heads_up">Heads Up!</p>
      {lines.map((line, i) =>
        line === '' ? (
          // eslint-disable-next-line react/no-array-index-key
          <p className="empty-row" key={`spacer-${i}`}>
            Empty
          </p>
        ) : (
          // eslint-disable-next-line react/no-array-index-key
          <p key={`line-${i}`}>{line}</p>
        )
      )}
      <div className="popup-control-buttons">
        <button
          type="button"
          className="btn right btn_cancel highlighted-btn"
          id="btn_cancel"
          name="cancel_delete"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  </div>
);

export default ReportGenerationPopup;
